import { render, staticRenderFns } from "./atendimento.vue?vue&type=template&id=82f8fc44&scoped=true"
import script from "./atendimento.vue?vue&type=script&lang=js"
export * from "./atendimento.vue?vue&type=script&lang=js"
import style0 from "./atendimento.vue?vue&type=style&index=0&id=82f8fc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f8fc44",
  null
  
)

export default component.exports